import styled from 'styled-components';
import { CarouselScrollContainerMixin } from '../../mixins/components/CarouselScrollContainerMixin';
import { Flex } from '../Flex/Flex';
export var StyledCarouselScrollContainer = /*#__PURE__*/styled(Flex).withConfig({
  displayName: "StyledCarouselScrollContainer",
  componentId: "c11n-8-107-0__sc-1jrjjf3-0"
})(["", ""], CarouselScrollContainerMixin);